<template>
	<div>
		<!-- subscription Dialog -->
		<!-- <modal
			v-if="user && user.userSubscriptions && user.userSubscriptions[0]"
            class="swap-modal modal-greeting"
            size="small-medium"
            @close="close"
			:layerIndex="9999"
			:hide-footer="true">
            <template slot="header">
                <h5 class="mb-0">{{ $t('We happy to see you!') }}</h5>
            </template>
            <template slot="body">
                <h2 class="mb-4 mt-4 text-left text-white">{{ $t('HELLO') }} {{user && user.name ? user.name : ''}}</h2>
                <p class="mb-0 text-left">{{ $t('Your') }} <span class="text-primary">{{user && user.userSubscriptions && user.userSubscriptions[0] ? user.userSubscriptions[0].package_name : ''}}</span> {{ $t('subscriptions is active') }}</p>
				<p class="mb-0 text-left">{{ $t('Get started within minutes! Watch this ') }}<a href="https://support.grafiaslive.com/get-started/quick-start" class="text-priamry" target="_blank">tutorial</a>{{ $t(' video.') }}</p>
				<p class="mb-4 text-left min-w420px">{{ $t('You can also check out our help pages, or reach out to us!') }}</p>
                <div class="d-flex text-left min-w420px"><a href="https://support.grafiaslive.com" target="_blank" class="text-primary">https://support.grafiaslive.com</a></div>
                <span class="d-flex mb-4 text-left min-w420px"><p class="mr-1">{{ $t('Email') }}:</p><p class="text-primary">support@grafiaslive.com</p></span>
                <p class="mb-4 text-left">{{ $t('Thank you for using Grafias.') }}</p>
                <p class="mb-0 text-left">{{ $t('Cheers') }}</p>
                <p class="mb-4 text-left">{{ $t('Grafias Team') }}</p>
			</template>
            <div slot="footer" class="text-center">
            </div>
		</modal> -->
		<!-- Greetings colab Dialog -->
        <!-- <modal
			v-if="user && user.collaborators && user.collaborators[0]"
            class="swap-modal"
            size="small-medium"
            @close="close"
			:hide-footer="true">
            <template slot="header">
                <h5 class="mb-0">{{ $t('We happy to see you!') }}</h5>
            </template>
			<template slot="body">
                <h2 class="mb-4 mt-4 text-left text-white">{{ $t('HELLO') }} {{user && user.name ? user.name : ''}}</h2>
                <p class="mb-0 text-left">{{ $t('You are invited by ') }} <span class="text-primary">{{user && user.collaborators && user.collaborators[0] ? user.collaborators[0].inviter_name : ''}}</span> {{ $t('to collaborate on GRAFIAS for ') }}{{rundownsData && rundownsData ? rundownsData : ''}}</p>
				<p class="mb-0 text-left">{{ $t('Get started within minutes! Watch this ') }}<a href="https://support.grafiaslive.com/get-started/quick-start" class="text-priamry" target="_blank">tutorial</a>{{ $t(' video.') }}</p>
                <p class="mb-4 text-left min-w420px">{{ $t('You can also check out our help pages, or reach out to us!') }}</p>
                <div class="d-flex text-left min-w420px"><a href="https://support.grafiaslive.com" target="_blank" class="text-primary">https://support.grafiaslive.com</a></div>
                <span class="d-flex mb-4 text-left min-w420px"><p class="mr-1">{{ $t('Email') }}:</p><p class="text-primary">support@grafiaslive.com</p></span>
                <p class="mb-4 text-left">{{ $t('Thank you for using Grafias.') }}</p>
                <p class="mb-0 text-left">{{ $t('Cheers') }}</p>
                <p class="mb-4 text-left">{{ $t('Grafias Team') }}</p>
			</template>
            <div slot="footer" class="text-center">
            </div>
		</modal> -->
		<!-- Greetings Dialog -->
        <!-- <modal
			v-if="user.userSubscriptions.length === 0 && user.collaborators.length === 0 && user.assignPackages.length === 0"
            class="swap-modal"
            size="small-medium"
            @close="close"
			:hide-footer="true">
            <template slot="header">
                <h5 class="mb-0">{{ $t('We happy to see you!') }}</h5>
            </template>
            <template slot="body">
                <h2 class="mb-4 mt-4 text-left text-white">{{ $t('HELLO') }} {{user && user.name ? user.name : ''}}</h2>
                <p class="mb-0 text-left">{{ $t('Congratulations. You are on board!') }}</p>
                <p class="mb-4 text-left">{{ $t('And your FREE account has started') }}.</p>
                <p class="mb-4 text-left">{{ $t('Get started within minutes! Watch this ') }}<a href="https://support.grafiaslive.com/get-started/quick-start" class="text-priamry" target="_blank">tutorial</a>{{ $t(' video.') }}</p> -->
                <!-- <p class="mb-4 text-left">{{ $t('Check out our ')}}
					<router-link to='/settings?menu=subscribe'
					class="text-primary">{{$t('subscription page')}}</router-link> {{$t(' to find a package') }}.
				</p> -->
                <!-- <p class="mb-4 text-left min-w420px">{{ $t('Hari and Erik, and the Grafias Team') }}</p> -->
                <!-- <h5 class="mb-1 text-left min-w420px">{{ $t('Resources') }}:</h5> -->
                <!-- <p class="mb-4 text-left min-w420px">{{ $t('You can also check out our help pages, or reach out to us!') }}</p>
                <div class="d-flex text-left min-w420px"><a href="https://support.grafiaslive.com" target="_blank" class="text-primary">https://support.grafiaslive.com</a></div>
                <span class="d-flex mb-4 text-left min-w420px"><p class="mr-1">{{ $t('Email') }}:</p><p class="text-primary">support@grafiaslive.com</p></span>
                <p class="mb-4 text-left">{{ $t('Thank you for using Grafias.') }}</p>
                <p class="mb-0 text-left">{{ $t('Cheers') }}</p>
                <p class="mb-4 text-left">{{ $t('Grafias Team') }}</p>
			</template>
            <div slot="footer" class="text-center">
            </div>
		</modal> -->
	</div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
// import Modal from '@/components/Modal.vue';
import usersApi from '@/api/user';
import assignPackagesApi from '@/api/assign-packages';
import authApi from '@/api/auth';
import { duplicateVar } from '@/lib/helper';

export default {
	name: 'ModalFirstGreeting',
	components: {
		// Modal,
	},
	props: {
		rundowns: {
		},
	},
	mounted() {
	},
	data: () => ({
		assigneePackage: [],
		// set settings user
		settings: null,
		isEnableAdvance: false,
		isEnableDummy: true,
		isEnableAllPreview: false,
		isEnableShowLogo: false,
		isTourVisible: false,
		lastCategoryTemplate: 0,
		lastKeywordTemplate: '',
		lastCategoryGallery: 0,
		lastKeywordGallery: '',
	}),
	methods: {
		...mapActions({
			setUser: 'setUser',
		}),
		close() {
			this.$emit('close');
			const callback = () => {
				this.setSettingsData();
				this.setTrueTour();
			};
			const errorCallback = () => {
			};
			usersApi.setLogin(callback, errorCallback);
		},
		confirmQuotation(data, action) {
			this.$emit('close');
			const callback = () => {
			};
			const errorCallback = () => {
			};
			const params = {};
			if (action === 'ok') {
				params.is_confirm = 1;
			} else {
				params.is_confirm = 0;
			}
			assignPackagesApi.update(data.id, params, callback, errorCallback);
		},
		setSettingsData() {
			// @TODO: catch variable user setting if setting is undefined
			const settings = JSON.parse(this.user.settings);
			if (settings) {
				const settingsString = this.user.settings;
				const settings = JSON.parse(settingsString);
				this.settings = settings;
				this.isEnableAdvance = settings && settings.is_enable_advance_layout ? duplicateVar(settings.is_enable_advance_layout) : false;
				this.isEnableDummy = settings && settings.is_enable_dummy_item_data ? duplicateVar(settings.is_enable_dummy_item_data) : false;
				this.isEnableAllPreview = settings && settings.is_enable_all_preview ? duplicateVar(settings.is_enable_all_preview) : false;
				this.isEnableShowLogo = settings && settings.is_enable_show_logo ? duplicateVar(settings.is_enable_show_logo) : false;
				this.isShowTour = settings && settings.is_tour_visible ? duplicateVar(settings.is_tour_visible) : false;
				this.lastCategoryTemplate = settings && settings.last_category_template ? duplicateVar(settings.last_category_template) : 0;
				this.lastKeywordTemplate = settings && settings.last_keyword_template ? duplicateVar(settings.last_keyword_template) : '';
				this.lastCategoryGallery = settings && settings.last_category_gallery ? duplicateVar(settings.last_category_gallery) : 0;
				this.lastKeywordGallery = settings && settings.last_keyword_gallery ? duplicateVar(settings.last_keyword_gallery) : '';
				if (this.lastCategoryTemplate !== 0) {
					this.category = this.lastCategoryTemplate;
					this.categoryId = this.lastCategoryTemplate;
				} else {
					this.category = 'all';
				}
				if (this.lastKeywordTemplate) {
					this.keyword = this.lastKeywordTemplate;
				} else {
					this.keyword = '';
				}
			} else {
			// @TODO: catch variable user setting if setting is undefined
				const settingsString = this.user.settings;
				const settings = JSON.parse(settingsString);
				this.settings = settings;
				this.isEnableAdvance = 0;
				this.isEnableDummy = 0;
				this.isEnableAllPreview = 0;
				this.isEnableShowLogo = 0;
				this.isShowTour = false;
				this.lastCategoryTemplate = 1;
				this.lastKeywordTemplate = '';
				this.lastCategoryGallery = 1;
				this.lastKeywordGallery = '';
			}
			this.setTrueTour();
		},
		setTrueTour() {
			this.settings.is_enable_advance_layout = this.isEnableAdvance;
			this.settings.is_enable_dummy_item_data = this.isEnableDummy;
			this.settings.is_enable_all_preview = this.isEnableAllPreview;
			this.settings.is_enable_show_logo = this.isEnableShowLogo;
			this.settings.is_tour_visible = true;
			this.settings.last_category_template = this.lastCategoryTemplate;
			this.settings.last_keyword_template = this.lastKeywordTemplate;
			this.settings.last_category_gallery = this.lastCategoryGallery;
			this.settings.last_keyword_gallery = this.lastKeywordGallery;
			// this.settings.background_color = this.colorBackground;
			const paramsSettings = { settings: JSON.stringify(this.settings) };
			const layout = paramsSettings;
			const params = layout;
			const callback = (response) => {
				const user = response.data;
				this.setUser(user);
			};
			const errorCallback = () => {
			};
			authApi.updateProfile(params, callback, errorCallback);
		},
	},
	computed: {
		...mapGetters({
			isLoggedIn: 'isLoggedIn',
			user: 'user',
		}),
		rundownsData() {
			const rundowns = [];
			if (this.rundowns.length > 0) {
				for (let index = 0; index < this.rundowns.length; index++) {
					const element = this.rundowns[index];
					rundowns.push(element.name);
				}
				return rundowns.toString();
			}
			return rundowns.toString();
		},
	},
	created() {
		this.setSettingsData();
	},
};
</script>

<style lang="scss" scoped>
</style>
